import React, { useCallback } from 'react';
import clsx from 'clsx';
import Depot from '../../../_shared/depot';
import * as styles from '../style.module.css';
const SegmentWrapperWithoutRef = ({ segmentedButtonType, allowMultipleSelection, supportLabelAbove, label, supportLabel, checked, id, disabled, onClick, ...commonProps }) => {
    const hasSupportLabel = segmentedButtonType === 'supported' && supportLabel;
    const segmentClasses = clsx(styles.segment, {
        [styles.checked]: checked,
        [styles.supportLabelAbove]: segmentedButtonType === 'supported' && supportLabelAbove,
    });
    const labelClasses = clsx(styles.label);
    const supportLabelClasses = clsx(styles.supportLabel);
    const handleKeyPressed = useCallback((event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            // @ts-ignore: no arguments needed
            onClick();
        }
    }, [onClick]);
    return (React.createElement("div", { className: segmentClasses, role: 'option', tabIndex: 0, onKeyDown: handleKeyPressed, onClick: onClick },
        Depot.createElement('input', {
            type: allowMultipleSelection ? 'checkbox' : 'radio',
            className: styles.input,
            ['aria-label']: label,
            ['aria-disabled']: !!disabled,
            checked,
            id,
            tabIndex: -1,
            ...commonProps,
        }),
        React.createElement("label", { className: labelClasses, htmlFor: id }, label),
        hasSupportLabel && (React.createElement("label", { className: supportLabelClasses, htmlFor: id }, supportLabel))));
};
const SegmentWrapper = Depot.withRef(SegmentWrapperWithoutRef);
SegmentWrapper.displayName = 'SegmentWrapper';
export default SegmentWrapper;
//# sourceMappingURL=index.js.map